import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Route, Redirect, Switch } from 'react-router-dom';
import url from '../helpers/url';
import { getData } from '../helpers/request';
import { userCheckLogin } from '../redux/actions/user.actions';

// Components
import Landing from './Landing';
import LoginPage from './authentication/LoginPage';
import Dashboard from './main/dashboard/Dashboard';
import Reconciliation from './main/reconciliation/Reconciliation';
import DonorSearchTool from './main/donor-search-tool/DonorSearchTool';

class PrivateRoute extends Component {
    constructor(props) {
        super(props);
        this.verfiedAuthentication = false;
    }

    async componentDidMount() {
        const { user: { isAuthenticated }, userCheckLogin} = this.props;
        if (!isAuthenticated) {
            const result = await getData({ url: url.isAuthenticated });
            const { success, data } = result;

            // Verify login and handle accordingly
            this.verfiedAuthentication = true;
            if (success) {
                userCheckLogin(data[0]);
            } else {
                this.forceUpdate();
            }
        } else {
            this.verfiedAuthentication = true;
            this.forceUpdate();
        }
    }
    render() {
        // We do not reroute anywhere if we haven't check the authentication at this point
        if (!this.verfiedAuthentication) {
            return null;
        }
        const { user: { isAuthenticated }, component: Component, ...rest } = this.props;
        return (
            <Route {...rest} render={(props) => (
                isAuthenticated ?
                    <Component {...props} /> :
                    <Redirect to={{
                        pathname: '/login',
                        state: { from: props.location }
                    }} />
            )}/>
        );
    }
}

const mapStateToProps = (state, ownProps) => ({
    user: state.user
});

const PrivateRouteContainer = connect(
    mapStateToProps,
    { userCheckLogin }
)(PrivateRoute);

const Routes = () => (
    <Switch>
        <Route path="/" exact component={Landing} />
        <Route path="/login" component={LoginPage} />
        <Route path="/register" component={LoginPage} />
        <PrivateRouteContainer path='/dashboard/:clientType?/:clientId?/:progressId?/:tab?' component={Dashboard} />
        <PrivateRouteContainer path='/reconciliation' component={Reconciliation} />
        <PrivateRouteContainer path='/donor-search-tool' component={DonorSearchTool} />
    </Switch>
);

export default Routes



// WEBPACK FOOTER //
// ./src/components/Routes.jsx